

import axios, { AxiosResponse } from 'axios';
import {ApiResponse} from '../../../interface/IResponse';

import { BorrowerLoan, BorrowerLoanDetails, LoanStatusDetails, LoanAmortization, TypeOfLoanListResponse, ResponseNumberDataResponse, InterestRate, CreateLoanInput, MemberLoanDetails } from '../../../interface/MembersPortal/ILoan';


async function getBorrowerLoanDetailsFunction() : Promise<AxiosResponse<ApiResponse<BorrowerLoanDetails>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/Client/getBorrowerDetailsByToken";

        const response: AxiosResponse<ApiResponse<BorrowerLoanDetails>> = await axios.get<ApiResponse<BorrowerLoanDetails>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function getLoanStatusDetailsFunction(loanId: number): Promise<AxiosResponse<ApiResponse<LoanStatusDetails>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/Client/getLoanStatusByToken/" + loanId;

        const response: AxiosResponse<ApiResponse<LoanStatusDetails>> = await axios.get<ApiResponse<LoanStatusDetails>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function listTypeOfLoanFunction() : Promise<AxiosResponse<TypeOfLoanListResponse>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getTypeOfLoansList";

        const response: AxiosResponse<TypeOfLoanListResponse> = await axios.get<TypeOfLoanListResponse>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           throw error.response?.data.message;
        }
        else{
            throw error;
        }
   }
}

async function getInterestRateTermsByTypeOfLoanFunction(typeofLoanId: number) : Promise<AxiosResponse<ApiResponse<InterestRate[]>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getInterestRateTermsByTypeOfLoan/" + typeofLoanId;

        const response: AxiosResponse<ApiResponse<InterestRate[]>> = await axios.get<ApiResponse<InterestRate[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           throw error.response?.data.message;
        }
        else{
            throw error;
        }
   }
}

async function getMemberLoanDetailsByTokenFunction() : Promise<AxiosResponse<ApiResponse<MemberLoanDetails>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/Client/getMemberLoanDetailsByToken";

        const response: AxiosResponse<ApiResponse<MemberLoanDetails>> = await axios.get<ApiResponse<MemberLoanDetails>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           throw error.response?.data.message;
        }
        else{
            throw error;
        }
   }
}

async function createLoanFunction(createLoanInput: CreateLoanInput) : Promise<AxiosResponse<ApiResponse<number>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/Client/createLoanByToken";

        const response: AxiosResponse<ApiResponse<number>> = await axios.post<ApiResponse<number>>(apiUrl, createLoanInput, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           throw error.response?.data.message;
        }
        else{
            throw error;
        }
   }
}


//

const loanService = {
    getBorrowerLoanDetails: getBorrowerLoanDetailsFunction,
    getLoanStatusDetails: getLoanStatusDetailsFunction,
    listTypeOfLoan: listTypeOfLoanFunction,
    getInterestRateTermsByTypeOfLoan: getInterestRateTermsByTypeOfLoanFunction,
    getMemberLoanDetailsByToken: getMemberLoanDetailsByTokenFunction,
    createLoan: createLoanFunction
}

export default loanService;